import React from 'react';
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Paper,
} from '@mui/material';
import {
  FormPublicDesignFragment,
  FormPublicFieldFragment,
} from '@/graphql/fragment/form.public.fragment';
import { FieldInputWrapper } from './InnovationTool.css';
import { DATA_PERMISSION_ID } from './utils';

interface Props {
  field: FormPublicFieldFragment;
  values: Record<string, any>;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(
      field: T
    ): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  design: FormPublicDesignFragment;
}

export const Terms: React.FC<Props> = ({
  field,
  handleChange,
  values,
  design,
}) => {
  const option = field.options[0].title;
  const isPermissionId = field.id === DATA_PERMISSION_ID;

  return (
    <FieldInputWrapper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: isPermissionId ? 'center' : 'start',
          alignItems: isPermissionId ? 'center' : 'start',
          padding: isPermissionId
            ? { xs: '24px 12px', sm: '48px 32px' }
            : '0 0 0 10px',
          borderRadius: { sm: '8px' },
          background: '#fff',
          maxWidth: { xs: '100%', sm: '600px' },
          margin: isPermissionId ? '0 auto' : 'unset',
          boxShadow: { xs: 1, sm: 3 },
        }}
      >
        {isPermissionId && (
          <Paper
            elevation={2}
            sx={{
              padding: { xs: '24px 12px' },
              borderRadius: { xs: '8px', sm: '16px' },
              backgroundColor: '#fff !important',
              maxWidth: { xs: '100%', sm: '600px' },
              margin: '0 auto',
              maxHeight: { xs: '300px', sm: '350px' },
              overflowY: 'auto',
              boxShadow: 'none',
            }}
          >
            <Box
              sx={{
                fontWeight: 300,
                textAlign: 'left',
                color: design.colors.question,
                whiteSpace: 'pre-wrap',
                fontSize: { xs: '14px', sm: '16px' },
                marginBottom: { xs: '24px', sm: '32px' },
              }}
            >
              {option}
            </Box>
          </Paper>
        )}
        <FormControlLabel
          control={
            <Checkbox
              name={field.id}
              checked={!!values[field.id]}
              onChange={(e) => {
                handleChange({
                  target: {
                    name: field.id,
                    value: e.target.checked,
                  },
                });
              }}
              sx={{
                color: design.colors.question,
                '&.Mui-checked': {
                  color: design.colors.question,
                },
              }}
            />
          }
          label={
            <Typography
              sx={{
                color: design.colors.question,
                fontSize: { xs: '14px', sm: '16px' },
                fontWeight: 500,
              }}
            >
              {isPermissionId ? 'I agree to the terms above.' : 'I accept'}
            </Typography>
          }
          sx={{
            marginTop: { xs: '8px', sm: '8px' },
            border: 'none !important',
            background: 'none !important',
            boxShadow: 'none !important',
          }}
        />
      </Box>
    </FieldInputWrapper>
  );
};
